import { render, staticRenderFns } from "./SupportModal.vue?vue&type=template&id=7ffd66b1"
import script from "./SupportModal.vue?vue&type=script&lang=js"
export * from "./SupportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports